export const CONTACT_PLATFORMS = ['Instagram', 'TikTok', 'YouTube', 'LinkedIn', 'Pinterest', 'X'] as const

export const CONTACT_BUDGETS = ['Under £1.5k', '£1.5k to £3k', '£3k to £6k', '£6k and up', 'Not sure yet'] as const

export const PLAN_TO_BUDGET: Record<string, string> = {
    starter: 'Under £1.5k',
    growth: '£1.5k to £3k',
    scale: '£3k to £6k',
    enterprise: '£6k and up'
}

export const CALL_TIMES = ['09:30', '11:00', '13:30', '15:00', '16:30'] as const

export const CONTACT_TIMEZONE = 'London time'
